/**
 * 商品 mock 資料 — 完整 Product schema（見 schema.md）。
 * 對應 API: GET /api/products
 *
 * 後台串接時，此檔可整個移除，由 productsApi.js 直接呼叫真實 API。
 */

export const PRODUCTS = [
  {
    id: 'sereno-g2-23',
    name: 'TARGET SERENO G2 23g 鈴木徹 (Toru Suzuki) 選手款 Swiss Point',
    brand: 'TARGET',
    categoryId: 'barrel',
    price: 1200,
    originalPrice: 1480,
    description: 'SERENO GENERATION 2 · TORU SUZUKI SIGNATURE · SWISS POINT',
    images: ['dart-full'],
    specs: {
      '品牌':    'TARGET DARTS · 英國',
      '系列':    'SERENO Generation 2',
      '選手款':  '鈴木 徹 / Toru Suzuki',
      '類型':    '硬式飛鏢 Steel Tip',
      '重量':    '23 g（±0.1g）',
      '長度':    '52.0 mm',
      '最大直徑': '7.4 mm',
      '材質':    '鎢鋼 Tungsten 95%',
      '握感':    '細密環狀刻紋 · 中段重心',
      '標針':    'Swiss Point 可調式螺旋固定',
      '內含':    '標身 ×3、Pro Ultra Flight ×3、Pro Grip Shaft ×3、收納盒 ×1',
      '產地':    '英國 設計 / 中國 製造',
    },
    variants: [
      { id: 'sereno-g2-21-swiss',  attrs: { weight: '21g', tip: 'Swiss Point' },     stock: 12, available: true },
      { id: 'sereno-g2-23-swiss',  attrs: { weight: '23g', tip: 'Swiss Point' },     stock: 8,  available: true },
      { id: 'sereno-g2-25-swiss',  attrs: { weight: '25g', tip: 'Swiss Point' },     stock: 4,  available: true },
      { id: 'sereno-g2-23-steel',  attrs: { weight: '23g', tip: 'Standard Steel' },  stock: 6,  available: true },
      { id: 'sereno-g2-20-soft',   attrs: { weight: '20g', tip: '2BA Soft' },        stock: 0,  available: false },
    ],
    tags: ['new', 'best'],
    rating: 4.9,
    reviewCount: 138,
    soldCount: 2418,
    stock: 30,
    status: 'active',
    createdAt: '2025-11-05',
  },
  {
    id: 'sereno-g2-21',
    name: 'TARGET SERENO G2 21g 鈴木徹 選手款 Steel',
    brand: 'TARGET',
    categoryId: 'barrel',
    price: 1180,
    originalPrice: null,
    description: 'SERENO GENERATION 2 · 21g · STANDARD STEEL',
    images: ['dart-full'],
    specs: { '品牌': 'TARGET DARTS', '重量': '21 g', '材質': '鎢鋼 95%' },
    variants: [
      { id: 'sereno-g2-21-steel', attrs: { weight: '21g', tip: 'Standard Steel' }, stock: 5, available: true },
    ],
    tags: ['hot'],
    rating: 4.7,
    reviewCount: 64,
    soldCount: 980,
    stock: 5,
    status: 'active',
    createdAt: '2025-11-01',
  },
  {
    id: 'effect-tk-21',
    name: 'DYNASTY EFFECT TYPE-K 21g 浅田齊吾 選手款',
    brand: 'DYNASTY',
    categoryId: 'barrel',
    price: 1580,
    originalPrice: null,
    description: 'EFFECT TYPE-K · SEIGO ASADA SIGNATURE',
    images: ['dart-full'],
    specs: { '品牌': 'DYNASTY · 日本', '重量': '21 g', '材質': '鎢鋼 90%' },
    variants: [
      { id: 'effect-tk-21-only', attrs: { weight: '21g' }, stock: 7, available: true },
    ],
    tags: ['hot'],
    rating: 4.8,
    reviewCount: 92,
    soldCount: 1340,
    stock: 7,
    status: 'active',
    createdAt: '2025-09-12',
  },
  {
    id: 'discovery-20',
    name: 'COSMO DARTS DISCOVERY LABEL 20g 川上佳和 選手款',
    brand: 'COSMO',
    categoryId: 'barrel',
    price: 1420,
    originalPrice: null,
    description: 'DISCOVERY LABEL · YOSHIKAZU KAWAKAMI',
    images: ['dart-full'],
    specs: { '品牌': 'COSMO DARTS · 日本', '重量': '20 g' },
    variants: [
      { id: 'discovery-20-only', attrs: { weight: '20g' }, stock: 9, available: true },
    ],
    tags: [],
    rating: 4.6,
    reviewCount: 41,
    soldCount: 720,
    stock: 9,
    status: 'active',
    createdAt: '2025-08-04',
  },
  {
    id: 'raptor-22',
    name: 'TARGET RAPTOR 22g 軟式飛鏢 鎢90% 入門精選',
    brand: 'TARGET',
    categoryId: 'barrel',
    price: 980,
    originalPrice: null,
    description: 'RAPTOR · 入門首選 · 軟式',
    images: ['dart-full'],
    specs: { '品牌': 'TARGET DARTS', '重量': '22 g', '材質': '鎢鋼 90%' },
    variants: [
      { id: 'raptor-22-soft', attrs: { weight: '22g', tip: '2BA Soft' }, stock: 24, available: true },
    ],
    tags: ['best'],
    rating: 4.5,
    reviewCount: 211,
    soldCount: 3120,
    stock: 24,
    status: 'active',
    createdAt: '2025-06-20',
  },
  {
    id: 'lstyle-flight-dragon',
    name: 'L-style EZ FLIGHT L1 標準型 dragon 限定設計 (3片入)',
    brand: 'L-style',
    categoryId: 'flight',
    price: 320,
    originalPrice: null,
    description: 'EZ FLIGHT L1 · DRAGON 限定金箔燙印',
    images: ['dart-flight'],
    specs: { '品牌': 'L-style', '型式': 'L1 STANDARD', '入數': '3 片' },
    variants: [
      { id: 'lstyle-l1-dragon-blue', attrs: { color: 'BLUE' }, stock: 30, available: true },
    ],
    tags: ['new'],
    rating: 4.8,
    reviewCount: 56,
    soldCount: 480,
    stock: 30,
    status: 'active',
    createdAt: '2025-10-27',
  },
  {
    id: 'fit-point-plus',
    name: 'FIT POINT PLUS 標針 鎢鋼鍍鈦 60支裝',
    brand: 'FIT',
    categoryId: 'tip',
    price: 480,
    originalPrice: null,
    description: '2BA 通用 · 鈦鍍層 · 60 PCS',
    images: ['dart-tip'],
    specs: { '品牌': 'FIT', '規格': '2BA 通用', '入數': '60 支' },
    variants: [
      { id: 'fit-point-plus-60', attrs: { count: '60支' }, stock: 80, available: true },
    ],
    tags: [],
    rating: 4.7,
    reviewCount: 98,
    soldCount: 2150,
    stock: 80,
    status: 'active',
    createdAt: '2025-05-10',
  },
  {
    id: 'pro-grip-shaft',
    name: 'TARGET PRO GRIP SHAFT Medium 標桿 (3支入)',
    brand: 'TARGET',
    categoryId: 'shaft',
    price: 280,
    originalPrice: null,
    description: 'Pro Grip Shaft · Medium · 3 PCS',
    images: ['dart-shaft'],
    specs: { '品牌': 'TARGET', '長度': 'Medium', '入數': '3 支' },
    variants: [
      { id: 'pro-grip-medium', attrs: { size: 'Medium' }, stock: 50, available: true },
    ],
    tags: [],
    rating: 4.6,
    reviewCount: 73,
    soldCount: 1620,
    stock: 50,
    status: 'active',
    createdAt: '2025-04-01',
  },
];
